import api from './api';

export function getData(loggedWith) {
    return new Promise((resolve, reject) => {
        return api.get(`backup/status?email=${loggedWith}`)
            .then(reponse => resolve(reponse))
            .catch(error => reject(error))
    })
}

export function getImplantationPending(loggedWith) {
    return new Promise((resolve, reject) => {
        return api.get(`implantation/pending?email=${loggedWith}`)
            .then(reponse => resolve(reponse))
            .catch(error => reject(error))
    })
}

export function changeImplantationStatus(status) {
    return new Promise((resolve, reject) => {
        return api.post('implantation/pending/status', status)
        .then(response => resolve(response))
        .catch(error => reject(resolve))
    });
}